import { render, staticRenderFns } from "./TractContentAllocations.vue?vue&type=template&id=8dfee66e&"
import script from "./TractContentAllocations.vue?vue&type=script&lang=js&"
export * from "./TractContentAllocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports